import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { JumpLink } from '@aok/ui-elements'

import defaultProps from '../../../utils/propTypes/defaultProps'

import SmallContentContainer from '../../_layouts/SmallContentContainer/SmallContentContainer'
import AllroundContainer from '../../_layouts/AllroundContainer'
import ArticleSharing from '../ArticleSharing/ArticleSharing'

import { EasyLanguagePageContext } from '../../../context/EasyLanguagePageContext'
import { BREAKPOINT_600 } from '../../../utils/constants/breakpoints'
import { useWindowSize } from '../../../hooks/customHooks'

const T005 = ({ overlayData, targetId }) => {
  const [windowWidth] = useWindowSize()
  const { isEasyLanguagePage } = useContext(EasyLanguagePageContext)

  return (
    <AllroundContainer dataTrackingName="T005">
      <SmallContentContainer isArticleContainer isEasyLanguagePage={isEasyLanguagePage}>
        <div className="flex justify-center 840:-mx-24 1000:-mx-32">
          <hr className="text-dfe3e6 w-full" />
        </div>
        {windowWidth > BREAKPOINT_600 ? (
          <div
            className={`flex ${isEasyLanguagePage ? 'justify-end 600:px-24 840:px-0' : 'justify-between px-8 1280:px-0'} pt-16`}
          >
            {!isEasyLanguagePage && <ArticleSharing overlayData={overlayData} />}
            <JumpLink targetId={targetId} title="Nach oben" arrowDirection="up" variant="light" />
          </div>
        ) : (
          <div className={`flex flex-col ${isEasyLanguagePage ? 'items-end' : 'items-center'} pt-16`}>
            <JumpLink targetId={targetId} title="Nach oben" arrowDirection="up" variant="light" />
            {!isEasyLanguagePage && <ArticleSharing overlayData={overlayData} className="mt-32" />}
          </div>
        )}
      </SmallContentContainer>
    </AllroundContainer>
  )
}

T005.propTypes = {
  targetId: PropTypes.string,
  overlayData: PropTypes.shape({
    text: PropTypes.string,
    headline: PropTypes.string,
  }),
}

T005.defaultProps = {
  overlayData: {
    headline: defaultProps.HEADLINE,
    text: defaultProps.DESCRIPTION_RICH,
  },
}

export default T005
